"use strict";

var e = require("react");
function t() {
  return (t = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var l = arguments[t];
      for (var i in l) Object.prototype.hasOwnProperty.call(l, i) && (e[i] = l[i]);
    }
    return e;
  }).apply(this, arguments);
}
function l(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function i(e, t, l) {
  return void 0 === l && (l = !1), l ? String(e).indexOf(String(t)) > -1 : String(e).toLowerCase().indexOf(String(t).toLowerCase()) > -1;
}
var r = function (e, t, l) {
    return void 0 !== l && void 0 !== t && "object" == typeof e && e.hasOwnProperty(t) && e.hasOwnProperty(l);
  },
  n = function (e, t, l, i, n) {
    if (void 0 === n && (n = !1), !e || !t) return !1;
    if (Array.isArray(e)) {
      if (r(t, l, i)) {
        var a = e.findIndex(function (e) {
          return e[l] === t[l];
        });
        return n ? a : a > -1;
      }
      var s = e.indexOf(t);
      return n ? s : s > -1;
    }
    return r(t, l, i) ? e[l] === t[l] : e === t;
  };
function a(e, t) {
  return e.sort(t ? function (e, l) {
    return e[t] < l[t] ? -1 : 1;
  } : function (e, t) {
    return e < t ? -1 : 1;
  });
}
function s(e, t) {
  if (e.length !== t.length) return !1;
  for (var l = e.length; l;) {
    if (e[l] !== t[l]) return !1;
    l--;
  }
  return !0;
}
var o = function (e) {
  return e || [];
};
function c(e) {
  var t = 1,
    l = "",
    i = (e || "").split("%"),
    r = i.length;
  r > 0 && (l += i[0]);
  for (var n = 1; n < r; n++) {
    if ("s" === i[n][0] || "d" === i[n][0]) {
      var a = arguments[t++];
      l += "d" === i[n][0] ? Math.floor(a) : a;
    } else l += i[n][0] ? "%" + i[n][0] : "%" + i[++n][0];
    l += i[n].substring(1);
  }
  return l;
}
var d = /%[sdj]/;
function p(e) {
  for (var t = arguments.length, l = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) l[i - 1] = arguments[i];
  return d.test(e) ? c.apply(null, arguments) : Array.from(l).join(" ");
}
var u = function (e) {
    return null == e || Array.isArray(e) && !e.length;
  },
  h = e.memo(function (t) {
    var l = t.placeholder,
      n = t.value,
      a = t.numberDisplayed,
      s = t.multiple,
      o = t.valueKey,
      c = t.labelKey,
      d = t.manySelectedPlaceholder,
      h = t.allSelectedPlaceholder,
      f = t.allSelected,
      v = "";
    if (u(n)) v = l || "";else if (Array.isArray(n) && s) n.length <= a ? v = n.map(function (e) {
      return r(e, o, c) ? e[c] : e;
    }).join(", ") : d && "all" !== f ? v = i(d, "%s") ? p(d, n.length) : d : f && h && (v = i(h, "%s") ? p(h, n.length) : h);else {
      var b = Array.isArray(n) ? n[0] : n;
      v = r(b, o, c) ? b[c] : String(b);
    }
    return e.createElement("span", {
      className: u(n) ? "picky__placeholder" : void 0,
      "data-testid": "picky_placeholder"
    }, v);
  }, f);
function f(e, t) {
  return e.multiple === t.multiple && e.value === t.value && e.numberDisplayed === t.numberDisplayed && e.allSelected === t.allSelected && e.allSelectedPlaceholder === t.allSelectedPlaceholder;
}
h.defaultProps = {
  placeholder: "None selected",
  allSelectedPlaceholder: "%s selected",
  manySelectedPlaceholder: "%s selected"
}, h.displayName = "Picky(Placeholder)";
var v = e.forwardRef(function (t, l) {
  var i = t.onFilterChange;
  return e.createElement("div", {
    className: "picky__filter"
  }, e.createElement("input", {
    ref: l,
    type: "text",
    className: "picky__filter__input",
    "data-testid": "picky__filter__input",
    placeholder: t.placeholder,
    tabIndex: t.tabIndex,
    "aria-label": "filter options",
    onChange: function (e) {
      return i(e.target.value);
    }
  }));
});
v.defaultProps = {
  placeholder: "Filter..."
}, v.displayName = "Picky(Filter)";
var b = e.memo(function (t) {
  var l = t.id,
    i = t.item,
    n = t.isSelected,
    a = t.labelKey,
    s = t.selectValue,
    o = t.style,
    c = t.multiple,
    d = t.tabIndex,
    p = t.disabled,
    u = n ? "option selected" : "option",
    h = r(i, a, t.valueKey) ? i[a] : i;
  return e.createElement("div", {
    tabIndex: d,
    id: l,
    role: "option",
    style: o,
    "data-testid": "option",
    "data-selected": n ? "selected" : "",
    "aria-selected": n,
    className: u,
    onClick: function () {
      return !p && s(i);
    },
    onKeyPress: function (e) {
      e.preventDefault(), p || s(i);
    }
  }, e.createElement("input", {
    type: c ? "checkbox" : "radio",
    readOnly: !0,
    tabIndex: -1,
    disabled: p,
    checked: n,
    "aria-label": h,
    "data-testid": "option-checkbox"
  }), h);
}, y);
function y(e, t) {
  return e.multiple === t.multiple && e.isSelected === t.isSelected && e.id === t.id && e.item === t.item && e.tabIndex === t.tabIndex && e.disabled === t.disabled;
}
b.displayName = "Picky(Option)";
var m = e.memo(function (t) {
  var l = t.tabIndex,
    i = t.disabled,
    r = t.allSelected,
    n = t.id,
    a = t.selectAllText,
    s = t.toggleSelectAll,
    o = t.visible,
    c = e.createRef();
  return o ? (e.useEffect(function () {
    null !== c.current && (c.current.indeterminate = "partial" === r);
  }, [r]), e.createElement("div", {
    tabIndex: l,
    role: "option",
    "data-testid": "selectall",
    id: n + "-option-selectall",
    "data-selectall": "true",
    "aria-selected": "all" === r,
    className: "all" === r ? "option selected" : "option",
    onClick: s,
    onKeyPress: s
  }, e.createElement("input", {
    type: "checkbox",
    ref: c,
    readOnly: !0,
    "data-testid": "selectall-checkbox",
    tabIndex: -1,
    checked: "all" === r,
    "aria-label": "select all",
    disabled: i
  }), e.createElement("span", {
    "data-testid": "select-all-text"
  }, a))) : null;
}, g);
function g(e, t) {
  return e.tabIndex === t.tabIndex && e.disabled === t.disabled && e.allSelected === t.allSelected && e.selectAllText === t.selectAllText && e.visible === t.visible;
}
m.displayName = "Picky(SelectAll)";
var S = function (t) {
  var l = t.id,
    i = t.disabled,
    r = t.onClick,
    n = t.children,
    a = t.className,
    s = function (e, t) {
      if (null == e) return {};
      var l,
        i,
        r = {},
        n = Object.keys(e);
      for (i = 0; i < n.length; i++) t.indexOf(l = n[i]) >= 0 || (r[l] = e[l]);
      return r;
    }(t, ["id", "disabled", "onClick", "children", "className"]),
    o = l + "__button",
    c = ["picky__input", i ? "picky__input--disabled" : "", a].join(" ");
  return e.createElement("button", Object.assign({
    id: o,
    type: "button",
    className: c,
    onClick: r,
    "data-testid": "picky-input",
    disabled: i
  }, s), n);
};
S.displayName = "Picky(Button)";
var k = function (c) {
  var d, p;
  function u(e) {
    var t;
    return (t = c.call(this, e) || this).node = null, t.filter = null, t.state = {
      selectedValue: e.value || (e.multiple ? [] : null),
      open: e.open,
      filtered: !1,
      filteredOptions: [],
      allSelected: "none"
    }, t.toggleDropDown = t.toggleDropDown.bind(l(t)), t.toggleSelectAll = t.toggleSelectAll.bind(l(t)), t.onFilterChange = t.onFilterChange.bind(l(t)), t.selectValue = t.selectValue.bind(l(t)), t.allSelected = t.allSelected.bind(l(t)), t.handleOutsideClick = t.handleOutsideClick.bind(l(t)), t.isItemSelected = t.isItemSelected.bind(l(t)), t.focusFilterInput = t.focusFilterInput.bind(l(t)), t.getValue = t.getValue.bind(l(t)), t;
  }
  p = c, (d = u).prototype = Object.create(p.prototype), d.prototype.constructor = d, d.__proto__ = p;
  var f,
    y = u.prototype;
  return y.componentDidMount = function () {
    this.setState({
      allSelected: this.allSelected()
    }), this.focusFilterInput(!!this.state.open);
  }, y.componentWillUnmount = function () {
    document.removeEventListener("click", this.handleOutsideClick, !1);
  }, y.componentDidUpdate = function (e) {
    var t = this;
    if (this.props.options !== e.options || this.props.value !== e.value) {
      if (!this.props.multiple) return;
      var l = Array.isArray(e.value) ? s(e.value, this.props.value) : e.value === this.props.value,
        i = s(e.options, this.props.options),
        r = this.state.filtered ? this.state.filteredOptions : this.props.options,
        n = this.state.filtered ? this.state.filteredOptions.filter(function (e) {
          return !Array.isArray(t.props.value) || t.props.value.includes(e);
        }) : this.props.value;
      this.setState({
        allSelected: l && i ? this.allSelected() : this.allSelected(n, r)
      });
    }
  }, y.selectValue = function (e) {
    var t = this,
      l = this.props.value;
    if (this.props.multiple && Array.isArray(l)) {
      var i,
        r = n(l, e, this.props.valueKey, this.props.labelKey, !0);
      i = r > -1 ? [].concat(l.slice(0, r), l.slice(r + 1)) : [].concat(this.props.value, [e]), this.setState({
        allSelected: this.allSelected(i)
      }, function () {
        t.props.onChange(i);
      });
    } else this.props.onChange(e);
  }, y.getValue = function (e) {
    return void 0 !== this.props.valueKey ? e[this.props.valueKey] : e;
  }, y.allSelected = function (e, t) {
    var l = this.props,
      i = e || l.value,
      r = t || l.options;
    if (r && 0 === r.length) return "none";
    var n = r.map(this.getValue),
      o = Array.isArray(i) ? i.map(this.getValue) : [];
    return s(a(o), a(n)) ? "all" : o.length > 0 ? "partial" : "none";
  }, y.toggleSelectAll = function () {
    var e = this;
    this.props.disabled || this.setState(function (l) {
      return t({}, l, {
        allSelected: "all" === e.state.allSelected ? "none" : "all"
      });
    }, function () {
      if ("all" !== e.state.allSelected) {
        if (e.state.filtered) {
          var t = o(e.props.value).filter(function (t) {
            return !e.state.filteredOptions.includes(t);
          });
          e.props.onChange(t);
        } else e.props.onChange([]);
      } else if (e.state.filtered) {
        var l = [].concat(e.props.value, e.state.filteredOptions);
        e.props.onChange(l);
      } else e.props.onChange(e.props.options);
    });
  }, y.isItemSelected = function (e) {
    return n(this.props.value, e, this.props.valueKey, this.props.labelKey);
  }, y.renderOptions = function () {
    var t = this,
      l = this.state.filtered ? this.state.filteredOptions : this.props.options,
      i = this.props,
      n = i.labelKey,
      a = i.valueKey,
      s = i.multiple,
      o = i.render,
      c = i.tabIndex,
      d = i.renderList,
      p = i.disabled;
    return d ? d({
      items: l,
      selected: this.props.value,
      multiple: s,
      tabIndex: c,
      getIsSelected: this.isItemSelected,
      selectValue: this.selectValue,
      disabled: p
    }) : l.map(function (l, i) {
      var d = function (e, t, l) {
          return r(e, t, l) ? e[t] : e;
        }(l, a, n),
        u = t.isItemSelected(l);
      return "function" == typeof o ? o({
        index: i,
        item: l,
        isSelected: u,
        selectValue: t.selectValue,
        labelKey: n,
        valueKey: a,
        multiple: s,
        disabled: p
      }) : e.createElement(b, {
        key: d,
        item: l,
        isSelected: u,
        selectValue: t.selectValue,
        labelKey: n,
        valueKey: a,
        multiple: Boolean(s),
        tabIndex: c,
        disabled: Boolean(p),
        id: t.props.id + "-option-" + i
      });
    });
  }, y.onFilterChange = function (e) {
    var t = this,
      l = "function" == typeof this.props.filterTermProcessor ? this.props.filterTermProcessor(e) : e;
    if (this.props.getFilterValue && this.props.getFilterValue(l), !l.trim()) return this.setState({
      filtered: !1,
      filteredOptions: [],
      allSelected: o(this.props.value).length > 0 ? "partial" : "none"
    });
    var n = r(this.props.options && this.props.options[0], this.props.valueKey, this.props.labelKey),
      a = this.props.options.filter(function (e) {
        return n ? i(e[t.props.labelKey], l, !!t.props.caseSensitiveFilter) : i(e, l, t.props.caseSensitiveFilter);
      });
    this.setState({
      filtered: !0,
      filteredOptions: a
    }, function () {
      t.props.onFiltered && t.props.onFiltered(a);
    });
  }, y.handleOutsideClick = function (e) {
    var t = this.props.keepOpen || this.props.multiple;
    this.node && this.node.contains(e.target) && t || this.filter && this.filter.contains(e.target) || this.toggleDropDown();
  }, y.focusFilterInput = function (e) {
    this.filter && (e && this.props.defaultFocusFilter && this.filter.focus(), e || !0 !== this.props.clearFilterOnClose || (this.filter.value = ""));
  }, y.toggleDropDown = function () {
    var e = this;
    this.state.open ? document.removeEventListener("click", this.handleOutsideClick, !1) : document.addEventListener("click", this.handleOutsideClick, !1), this.setState(function (l) {
      return t({}, l, {
        open: !l.open,
        filtered: !e.props.clearFilterOnClose && l.filtered,
        filteredOptions: e.props.clearFilterOnClose ? [] : l.filteredOptions
      });
    }, function () {
      var t = !!e.state.open;
      e.focusFilterInput(t), t && e.props.onOpen ? e.props.onOpen() : !t && e.props.onClose && e.props.onClose();
    });
  }, y.render = function () {
    var t = this,
      l = this.props,
      i = l.placeholder,
      r = l.value,
      n = l.multiple,
      a = l.numberDisplayed,
      s = l.includeFilter,
      o = l.valueKey,
      c = l.labelKey,
      d = l.tabIndex,
      p = l.renderSelectAll,
      u = l.filterPlaceholder,
      f = l.disabled,
      b = l.buttonProps,
      y = this.state.open,
      g = "";
    y && (g += this.props.id + "-list");
    var k = this.props.id + "__button",
      x = {
        maxHeight: l.dropdownHeight,
        overflowY: "scroll"
      };
    return e.createElement("div", {
      ref: function (e) {
        t.node = e;
      },
      className: ["picky", l.className].join(" "),
      id: this.props.id,
      role: "combobox",
      "aria-controls": k,
      "aria-expanded": y,
      "aria-haspopup": y,
      "aria-owns": g,
      tabIndex: d
    }, e.createElement(S, Object.assign({
      id: this.props.id + "__button",
      disabled: f,
      onClick: this.toggleDropDown
    }, b), e.createElement(h, {
      allSelected: this.state.allSelected,
      placeholder: i,
      manySelectedPlaceholder: this.props.manySelectedPlaceholder,
      allSelectedPlaceholder: this.props.allSelectedPlaceholder,
      value: r,
      multiple: Boolean(n),
      numberDisplayed: a,
      valueKey: o,
      labelKey: c,
      "data-testid": "placeholder-component"
    })), e.createElement("div", {
      className: "picky__dropdown",
      id: this.props.id + "-list",
      "aria-hidden": !y,
      hidden: !y,
      style: y ? x : {
        visibility: "hidden"
      }
    }, s && e.createElement(v, {
      tabIndex: d,
      ref: function (e) {
        return t.filter = e;
      },
      placeholder: u,
      onFilterChange: this.filterDebounce
    }), p ? p({
      filtered: Boolean(this.state.filtered),
      allSelected: this.state.allSelected,
      toggleSelectAll: this.toggleSelectAll,
      tabIndex: d,
      multiple: Boolean(n),
      disabled: Boolean(f)
    }) : e.createElement(m, {
      visible: this.showSelectAll,
      tabIndex: d,
      disabled: !!f,
      allSelected: this.state.allSelected,
      id: this.props.id,
      selectAllText: this.props.selectAllText,
      toggleSelectAll: this.toggleSelectAll
    }), y && e.createElement("div", {
      "data-testid": "dropdown"
    }, this.renderOptions())));
  }, (f = [{
    key: "filterDebounce",
    get: function () {
      var e,
        t,
        l,
        i = this.props.filterDebounce || 0;
      return (i || 0) > 0 ? (e = this.onFilterChange, t = i, l = null, function () {
        for (var i = arguments.length, r = new Array(i), n = 0; n < i; n++) r[n] = arguments[n];
        l && clearTimeout(l);
        var a = this;
        l = setTimeout(function () {
          e.apply(a, r);
        }, t);
      }) : this.onFilterChange;
    }
  }, {
    key: "showSelectAll",
    get: function () {
      var e = this.props;
      return Boolean(!e.renderSelectAll && e.includeSelectAll && e.multiple && ("default" === this.props.selectAllMode && !this.state.filtered || "filtered" === this.props.selectAllMode));
    }
  }]) && function (e, t) {
    for (var l = 0; l < t.length; l++) {
      var i = t[l];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }(u.prototype, f), u;
}(e.PureComponent);
k.defaultProps = {
  id: "picky",
  numberDisplayed: 3,
  options: [],
  filterDebounce: 150,
  dropdownHeight: 300,
  onChange: function () {},
  tabIndex: 0,
  keepOpen: !0,
  selectAllText: "Select all",
  selectAllMode: "default",
  filterTermProcessor: function (e) {
    return e;
  }
}, exports.Picky = k;